import moment from 'moment';

var utils = new function () {
  var that = this;

  this.setCookie = function (cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
  };

  this.getCookie = function (cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  };

  this.deleteCookie = function (name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  };

  this.setLocalStorage = function (key, value) {
    localStorage.setItem(key, value);
  };

  this.getLocalStorage = function (key) {
    return localStorage.getItem(key);
  };

  this.removeLocalKey = function (key) {
    return localStorage.removeItem(key)
  }

  this.setAppData = function (key, value, expiry) {

    if (that.checkLocalStorage()) {
      that.setLocalStorage(key, value);
    } else {
      if (!expiry)
        expiry = 1;
      that.setCookie(key, value, expiry);

    }
  }

  this.titleCase = function (str) {
    return str.toLowerCase().replace(/\b(\w)/g, s => s.toUpperCase());
  }

  //checks if localstorage is available else go for cookies
  this.getAppData = function (key) {

    if (that.checkLocalStorage()) {

      return that.getLocalStorage(key);

    } else {

      return that.getCookie(key);

    }
  }

  this.deleteAppData = function (key) {

    if (that.checkLocalStorage()) {

      localStorage.removeItem(key)

    } else {

      that.deleteCookie(key);

    }
  }

  var replaceAllOccurances = function (str, search, replacement) {
    if (typeof str != 'string') return str;
    var resp = str.replace(/"/g, '');

    return resp;
  };

  this.getstringifiedformurlencoded = function (meta) {
    var jsonData = "";
    var delimiter = "";
    for (var key in meta) {
      if (meta.hasOwnProperty(key)) {
        var keyData = replaceAllOccurances(meta[key], '"', "");
        jsonData += delimiter + key + "=" + encodeURIComponent(keyData);
        delimiter = "&";
      }
    };
    return jsonData;
  }

  this.formatTime = function (date) {
    return `${String(new Date(date).getUTCHours()).padStart(2, "0")}:${String(new Date(date).getUTCMinutes()).padStart(2, "0")}`;
  }

  this.formatDateTime = function (dateString, timeSlot) {
    const date = new Date(dateString);
    const [startTime] = timeSlot.split("-");

    const [hours, minutes] = startTime.split(":");
    date.setHours(hours);
    date.setMinutes(minutes);

    const formattedDate = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });

    return `${formattedDate} ${formattedTime}`;
  };

  this.getDefaultSlots = function () {
    return ['10:00 - 10:30', '10:30 - 11:00', '11:00 - 11:30', '11:30 - 12:00', '12:30 - 13:00', '13:00 - 13:30', '13:30 - 14:00', '14:30 - 15:00', '15:30 - 16:00', '16:30 - 17:00'];
  };

  this.getMinDate = () => {
    let minDate;
    const today = new Date();
    const currentHours = today.getHours();

    if (currentHours < 17) {
      minDate = moment(today).add(1, "day").toDate();
    } else {
      minDate = moment(today).add(2, "day").toDate();
    }
    return minDate;
  };

  this.getMaxDate = () => {
    const today = new Date();
    return moment(today).add(14, "days").toDate();
  };

  this.getCurrentDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  
}();

export default utils;